import InfoIndicator, { InfoIndicatorProps } from '@ubnt/link-core-ui/components/InfoIndicator/InfoIndicator';
import Text from '@ubnt/ui-components/Text/Text';
import { TooltipProps } from '@ubnt/ui-components/Tooltip/Tooltip';
import Tooltip from '@ubnt/link-core-ui/components/Tooltip';
import { clsx } from 'clsx';
import { memo, useMemo } from 'react';

import { Flex } from 'components/Flex';

import classes from './ButtonPickerButton.module.scss';

export interface ButtonPickerButtonProps extends React.HTMLAttributes<HTMLDivElement> {
  infoContent?: InfoIndicatorProps['children'];
  isActive?: boolean;
  isDisabled?: boolean;
  isError?: boolean;
  isSelected?: boolean;
  label: React.ReactNode;
  tooltipDescription?: TooltipProps['description'];
}

const ButtonPickerButton = (props: ButtonPickerButtonProps) => {
  const { label, infoContent, isActive, isDisabled, isError, isSelected, tooltipDescription, ...rest } = props;

  const isStringLabel = typeof label === 'string';

  const button = useMemo(
    () => (
      <Flex
        className={clsx(
          classes.ButtonPickerButton,
          isStringLabel && classes.stringLabel,
          isActive && classes.isActive,
          isDisabled && classes.isDisabled,
          isSelected && classes.isSelected,
          isError && classes.isError
        )}
        alignCenter
        gap="s"
        {...rest}
      >
        {!isStringLabel && label}
        {isStringLabel && (
          <Text color="inherit" size="body">
            {label}
          </Text>
        )}
        {infoContent && <InfoIndicator severity="info2">{infoContent}</InfoIndicator>}
      </Flex>
    ),
    [infoContent, isStringLabel, isActive, isDisabled, isSelected, isError, label, rest]
  );

  if (tooltipDescription) {
    return (
      <Tooltip maxWidth={200} description={tooltipDescription}>
        {button}
      </Tooltip>
    );
  }

  return button;
};

const MemoizedButtonPickerButton = memo(ButtonPickerButton);

export default MemoizedButtonPickerButton;
